<section class="bg-image">
  <div class="scs-inner signup-confirmation-section">
    <div class="row">
      <div class="col-1 col-md-3"></div>
      <div class="col-10 col-md-6 scs-text-section">
        <h1>Registration successful!</h1>
        <p>Your account has been created successfully.</p>
        <div class="scs-inner-btn">
          <button _ngcontent-ng-cli-universal-c2=""
                  class="btn btn-outline-success btn-scs-text my-2 ng-star-inserted"
                  type="button" onclick="window.location.href='/'"> Continue </button>
        </div>
      </div>
      <div class="col-1 col-md-3"></div>
    </div>
  </div>
</section>
